<template>
  <div class="canceled-settlements-view container fluid">
    <v-card>
      <CanceledSettlementsTable />
    </v-card>
  </div>
</template>

<script>
import CanceledSettlementsTable from '@/components/settlements/CanceledSettlementsTable';

export default {
  name: 'CanceledSettlements',
  components: {
    CanceledSettlementsTable,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
  .canceled-settlements-view {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/settlements/CanceledSettlements.vue